import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18749c4d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=18749c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18749c4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18749c4d')) {
      api.createRecord('18749c4d', component.options)
    } else {
      api.reload('18749c4d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18749c4d&scoped=true&", function () {
      api.rerender('18749c4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/index.vue"
export default component.exports